import { styled } from "@material-ui/core";

export const TTHTPlanetWatchImageContainer = styled("div")(({ theme }) => ({
  width: "600px",
  marginLeft: theme.spacing(6),

  "& > img": {
    width: " 100%",
    border: `2px solid ${theme.palette.grey[400]}`,
  },

  [`${theme.breakpoints.down("sm")}`]: {
    width: "100%",
    marginLeft: 0,
  },
}));

export const TTHTPlanetWatchContentWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",

  "& * img": {
    marginLeft: "1rem",
  },

  [`${theme.breakpoints.down("sm")}`]: {
    flexDirection: "column",
  },
}));

export const TTHTPlanetWatchTextContainer = styled("div")(({ theme }) => ({
  maxWidth: "450px",

  [`${theme.breakpoints.down("sm")}`]: {
    width: "100%",
    maxWidth: "100%",
    marginBottom: theme.spacing(3),
  },
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/PlanetWatch/TTHTPlanetWatchSection.styled.js